// pages/FormViewerPage/components/CustomerInfoFields/index.tsx — CustomerInfoFields composition
import React from 'react';
import { NameField } from './NameField';
import { WhatsappField } from './WhatsappField';
import { EmailField } from './EmailField';
import { AddressSection } from './AddressSection';
import { ms } from '../../../../locales/ms';
import type { CustomerInfoFieldsProps } from './types';

const CustomerInfoFields: React.FC<CustomerInfoFieldsProps> = (props) => {
    const { blockSpacingClass, isSimpleEmbed, onCustomerDataChange } = props;
    // Honeypot anti-bot: di luar layar (bukan display:none agar bot tetap isi),
    // manusia tak pernah lihat/isi. Dicek di RPC submit_public_order.
    const honeypot = (
        <input type="text" name="company_website" autoComplete="off" tabIndex={-1} aria-hidden="true"
            value={(props.customerData as any).company_website || ''} onChange={onCustomerDataChange}
            className="absolute -left-[9999px] top-0 h-px w-px opacity-0" />
    );
    if (isSimpleEmbed) {
        return (
            <div className="space-y-2.5 relative">
                {honeypot}
                <NameField {...props} />
                <WhatsappField {...props} />
            </div>
        );
    }
    return (
        <div className={`${blockSpacingClass} space-y-2 relative`}>
            {honeypot}
            <h3 className="font-semibold text-slate-900 dark:text-slate-100">{ms(props.form, m => m.customerInfo, 'Informasi Pelanggan:')}</h3>
            <NameField {...props} />
            <WhatsappField {...props} />
            <EmailField {...props} />
            <AddressSection {...props} />
        </div>
    );
};

export default CustomerInfoFields;
